/**
* 应用入口
*/

import 'babel-polyfill'
import Vue from 'vue'

import App from '$components/App'
import router from '$routes'
import store from '$stores'
import echarts from 'echarts'
import CollectPlugin from '@finance/ssvue/src/plugins/collect'
import ToastPlugin from '@finance/ssvue/src/plugins/toast'
import { setAllHostName } from '@common/domain'
import cookie from 'js-cookie'
import url from '@common/url'

Vue.prototype.$echarts = echarts

/* =====导入ssvue插件===== */
Vue.use(CollectPlugin)
Vue.use(ToastPlugin)

// 引入调试工具
if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'test') {
  require('vconsole')
}

// 修改数据上报域名
if (process.env.NODE_ENV === 'production') {
  setAllHostName({
    collect: 'https://dataapi.ssjlicai.com'
  })
}

// PC端数据上报clientId设置为02
cookie.set('clientId', '02', {
  domain: url('domain')
})

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/app.js